export default "https://cdn-static.gokick.com/assets/4beacdc4d8fafa1e61a7f98396d8ad8b9ab7b90c/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";